// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Data
import data from 'csdd_data/latestVideos';
import YoutubeVideos from 'csdd_components/YoutubeVideos';

function LatestVideos() {
  const youtubeData = data.map(({ id, videoId }) => (
    <Grid item xs={12} md={6} lg={4} sx={{ mb: { xs: 3, lg: 0 } }} key={id}>
      <YoutubeVideos videoId={videoId} />
    </Grid>
  ));

  return (
    <MKBox component='section' py={6}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection='column'
          alignItems='center'
          sx={{ textAlign: 'center', my: 6, mx: 'auto', px: 0.75 }}
        >
          <Container sx={{ textAlign: 'center' }}>
            <MKTypography textGradient variant='h2' mb={1} mt={1}>
              Latest Videos
            </MKTypography>
          </Container>
          <MKTypography variant='body1' color='text'>
            Get the latest news and videos in the world of supply chain and
            procurement.
          </MKTypography>
        </Grid>
      </Container>
      {data.length === 0 ? (
        <MKTypography textAlign='center' color='warning'>
          Latest videos is not available at the moment.
        </MKTypography>
      ) : (
        <Container sx={{ mt: { xs: 8, lg: 8 } }}>
          <Grid container spacing={2}>
            {youtubeData}
          </Grid>
        </Container>
      )}
    </MKBox>
  );
}

export default LatestVideos;
